import React, { useState } from 'react';
import { IStep, PageContents } from './StrategyExercisePlan';
import { StyledPageDescription, StyledRowNumberContainer, StyledSelectSolutionContainer, StyledSolution } from './StrategyExercisePlan.styled';
import { PlanActivityTextField } from 'components/TextField/PlanActivityTextField';
import { STEPS } from 'models/exercises/IExercisePlan';

interface IStepThreeProps extends IStep {
  selectedSolutions: string[]; 
  setPnCList :React.Dispatch<React.SetStateAction<ProsAndConsList[]>>
}

export type ProsAndConsList = {
  pros: string[];
  cons: string[];
}

const SolutionProsAndCons: React.FC<{ 
  solution: string,
  prosAndCons: ProsAndConsList,
  setProsAndCons: (updated: ProsAndConsList) => void
  }> = ({ solution, prosAndCons, setProsAndCons }) => {

  const handleChange = (
    type: 'pros' | 'cons',
    index: number,
    value: string,
  ) => {
    const updatedList = [...prosAndCons[type]];
    updatedList[index] = value;
    setProsAndCons({ ...prosAndCons, [type]: updatedList });
  };

  const renderFields = (type: 'pros' | 'cons') => (
    prosAndCons[type].map((item, index) => (
      <PlanActivityTextField
        key={`${type}-${index}`}
        onChange={(value) => handleChange(type, index, value)}
        placeholder={''}
        initialValue={item}
      />
    ))
  );

  return (
    <React.Fragment>
      <StyledSelectSolutionContainer $isSelected={true}>
        <StyledRowNumberContainer><span>1.</span></StyledRowNumberContainer>
        <StyledSolution><span>{solution}</span></StyledSolution>
      </StyledSelectSolutionContainer>

      <StyledPageDescription>Pros:</StyledPageDescription>
      {renderFields('pros')}

      <StyledPageDescription>Cons:</StyledPageDescription>
      {renderFields('cons')}
    </React.Fragment>
  )
}

export const StepThreePage: React.FC<IStepThreeProps> = ({ content, setStep, selectedSolutions, setPnCList }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prosAndConsList, setProsAndConsList] = useState<ProsAndConsList[]>(
    selectedSolutions.map(() => ({ pros: ['', '', ''], cons: ['', '', ''] })),
  );

  //Turns the heading into "What are the pros/cons of option 1", then "What are the pros/cons of option 2"
  const modifiedContent = {
    ...content,
    heading: content.heading + ' ' + (currentIndex + 1),
  }

  const handleCtaClick = () => {
    if (currentIndex < selectedSolutions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const cleanedUpList = prosAndConsList.map(({ pros, cons }) => ({
        pros: pros.filter((item) => item !== ''),
        cons: cons.filter((item) => item !== ''),
      }))
      setPnCList(cleanedUpList);
      setStep(STEPS.STEP_FOUR);
    }
  };

  return (
    <PageContents key={currentIndex} content={modifiedContent} onCtaClick={handleCtaClick}>
      <SolutionProsAndCons
        solution={selectedSolutions[currentIndex]}
        prosAndCons={prosAndConsList[currentIndex]}
        setProsAndCons={(updated) => {
          const updatedList = [...prosAndConsList];
          updatedList[currentIndex] = updated;
          setProsAndConsList(updatedList);
        }}
      />
    </PageContents>
  )
}